var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icones/Interface, Essential/email-@-square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.49438,
    y: 4.76465,
    width: 27.0112,
    height: 27.0112,
    rx: 5,
    stroke: "#173134",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 13.4704C10 13.046 10.1686 12.639 10.4686 12.339C10.7687 12.0389 11.1757 11.8704 11.6 11.8704H24.4C24.8243 11.8704 25.2313 12.0389 25.5314 12.339C25.8314 12.639 26 13.046 26 13.4704V23.0704C26 23.4947 25.8314 23.9017 25.5314 24.2017C25.2313 24.5018 24.8243 24.6704 24.4 24.6704H11.6C11.1757 24.6704 10.7687 24.5018 10.4686 24.2017C10.1686 23.9017 10 23.4947 10 23.0704V13.4704ZM12.8152 13.4704L18 18.0072L23.1848 13.4704H12.8152ZM24.4 14.5336L18.5272 19.6728C18.3813 19.8006 18.194 19.871 18 19.871C17.806 19.871 17.6187 19.8006 17.4728 19.6728L11.6 14.5336V23.0704H24.4V14.5336Z",
    fill: "#173134"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.a0fd368b76fb410519436548459c2ec1.svg";
export { ForwardRef as ReactComponent };